module.exports = __webpack_public_path__ + "img/mother.616e026d.png";